// Demo/mock data used only as an offline fallback when the `payments`
// (pending proof) and `payments/proof` API endpoints are unreachable
// (e.g. local dev without the backend endpoints yet).
// Remove this file and the fallback wiring in ProofOfPayment.vue once the
// real backend endpoints are live.

const NAMES = [
    'Juma Mwakimbe', 'Asha N. Kessy', 'Elias Mrema', 'Fatuma Said',
    'Daniel K. Mushi', 'Grace Lyimo', 'Peter Shirima', 'Mariam Chande',
    'Godfrey Mollel', 'Neema Kimaro',
]

const BANKS = [
    { id: 1, name: 'CRDB Bank' },
    { id: 2, name: 'Azania Bank' },
]

function buildPayment(i) {
    const value = 800 + ((i * 137) % 4000)
    const deduction = (i % 4) * 25.5
    const paid = 0
    const daysAgo = (i * 3) % 14
    const date = new Date()
    date.setDate(date.getDate() - daysAgo)
    const bank = BANKS[i % BANKS.length]

    return {
        id: 8000 + i,
        sale_id: 7000 + i,
        beneficiary: {
            id: 500 + i,
            name: NAMES[i % NAMES.length],
            code: `SOC${(1000 + i).toString()}`,
        },
        saleNumber: `SN${(20260000 + i * 11).toString()}`,
        market: { code: 'MC', name: `Market Center ${1 + (i % 6)}` },
        account: {
            name: NAMES[i % NAMES.length],
            number: `0${(1200000000 + i * 977).toString()}`,
            abbreviation: 'USD',
        },
        bank,
        value,
        paid,
        deduction,
        amount: +(value - paid - deduction).toFixed(3),
        initiatedAt: date.toISOString(),
        initiatedBy: 'Payments Officer',
    }
}

export const MOCK_PENDING_PAYMENTS = Array.from({ length: 16 }, (_, i) => buildPayment(i + 1))

export const MOCK_PAYMENT_BANKS = BANKS

export function queryMockPendingPayments(query) {
    let rows = [...MOCK_PENDING_PAYMENTS]

    if (query && query.trim()) {
        const q = query.trim().toLowerCase()
        rows = rows.filter(p => p.beneficiary.name.toLowerCase().includes(q)
            || p.beneficiary.code.toLowerCase().includes(q)
            || p.saleNumber.toLowerCase().includes(q)
            || p.account.number.toLowerCase().includes(q))
    }

    return rows
}
